module.exports = __webpack_public_path__ + "static/media/gal3.32e34e03.jpg";